import { useMemo, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import ClientContext from 'contexts/ClientContext'
// import HomeSmile from 'components/assets/icons/HomeSmile'
import User from 'components/assets/icons/User'
import Notes from 'components/assets/icons/Notes'
import Thundercloud from 'components/assets/icons/Thundercloud'
import { getNavMenuIconColor } from 'helpers/styles'
import Link from 'components/common/Link/Link'
import style from './NavMenuFooter.module.scss'
import ThreeDots from 'components/assets/icons/ThreeDots'

const NavMenuFooter = ({ onNavItemClick, onToggleMenu }) => {
  const { pathname } = useLocation()
  const { color, colabelNeutralDark } = useContext(ClientContext)

  const navItems = useMemo(() => {
    const getColor = (page) => {
      const defaultColor = getNavMenuIconColor(pathname, page, true)
      return color
        ? defaultColor === '#FF9D0E'
          ? color
          : colabelNeutralDark
        : defaultColor
    }

    return [
      // not for MVP1
      // {
      //   icon: <HomeSmile styles={{ fill: getNavMenuIconColor(pathname, '/', true) }} />,
      //   title: 'Accueil',
      //   path: '/',
      // },
      {
        icon: <User styles={{ fill: getColor('/contacts') }} />,
        title: 'Coordonnées',
        path: '/contacts',
      },
      {
        icon: <Notes styles={{ fill: getColor('/contracts') }} />,
        title: 'Contrats',
        path: '/contracts',
      },
      {
        icon: <Thundercloud styles={{ fill: getColor('/claims') }} />,
        title: 'Sinistres',
        path: '/claims',
      },
    ]
  }, [color, colabelNeutralDark, pathname])

  return (
    <ul className={style.footer}>
      {navItems.map((item, index) => {
        return (
          <li key={`footer-nav-item-${index}`} className={style['footer-item']}>
            <Link
              className={style['footer-item-title']}
              label={<>
                {item.icon}
                {item.title}
              </>}
              onClick={() => onNavItemClick(item.path)}
              styles={color && {color: colabelNeutralDark}}
            />
          </li>
        )
      })}
      <li className={style['footer-item']} onClick={onToggleMenu}>
        <span className={style['footer-item-title']} style={color && {color: colabelNeutralDark}}>
          <ThreeDots className={style['footer-dots']} styles={color && {fill: colabelNeutralDark}} />
          Menu
        </span>
      </li>
    </ul>
  )
}

export default NavMenuFooter
